import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

// Selector
import { selectSessionKey } from "REDUX/Selector/SessionSelector"
import { getSpeedTestParticipantId } from "REDUX/Selector/RoomMetaDataSelector"
import { selectCurrentParticipantUniqueId } from "REDUX/Selector/SessionSelector";
 
// webSocket
import { socketMessage } from "WEBSOCKET/constants";
import {
  sendWebsocketMessage
} from "WEBSOCKET/WebsocketHandler";

// Utilities
import { ERROR } from "UTILS/Constants";

// Action
import { sessionActions } from "CONFIG/ActionFactory";

import SpeedTestHelper from './speedTestHelper';
const speedTestHelper = new SpeedTestHelper();

const SpeedTestComponent = (props) => {
  const uniqueId = useSelector(selectCurrentParticipantUniqueId);
  const speedTestParticipantId = useSelector(getSpeedTestParticipantId);
  const sessionKey = useSelector(selectSessionKey);

  const onComplete = (speedTest) => {
    const payload = {
      data: {
        category: socketMessage.category.PARTICIPANT,
        action: socketMessage.subCategories.PARTICIPANT.UPDATE_SPEED_TEST,
        sessionKey,
        remoteId: uniqueId,
        speedTest,
      }
    };
    sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      payload
    )();
  }

  const onServerError = () => {
    const speedTest = {
      result: -1,
    };
    const payload = {
      data: {
        category: socketMessage.category.PARTICIPANT,
        action: socketMessage.subCategories.PARTICIPANT.UPDATE_SPEED_TEST,
        sessionKey,
        remoteId: uniqueId,
        speedTest,
      }
    };
    sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      payload
    )();
  };

  const onTimeoutError = () => {
    sessionActions.setOwnSpeedTestError(ERROR.SPEED_TEST_TIME_OUT);
    sessionActions.saveSpeedTestParticipantId(null, null, null);
  };

  useEffect(() => {
    if (speedTestParticipantId === uniqueId) {
      sessionActions.setOwnSpeedTestError(null);
      speedTestHelper.startSpeedTest(
        onComplete,
        onServerError,
        onTimeoutError,
      );
    }
  }, [speedTestParticipantId]);

  useEffect(() => {
    return () => {
      speedTestHelper.clear();
    };
  }, []);

  // Nothing is displayed on the screen
  return null;
};

export default SpeedTestComponent;
